<!-- <div class="loading-overlay" *ngIf="loading">
    <mat-progress-bar mode="indeterminate" value="40" color="accent"></mat-progress-bar>
</div> -->

<app-loader></app-loader>
<router-outlet></router-outlet>
